import Vue from 'vue'
import Router from 'vue-router'

// creation
import ReportBase from '@/components/reports/new/ReportBase'
import ReportOutreachNew from '@/components/reports/new/ReportOutreachNew'
import ReportOutreachList from '@/components/reports/new/ReportOutreachList'
import ReportCustomersList from '@/components/reports/new/ReportCustomersList'
import ReportIndicatorsForm from '@/components/reports/new/ReportIndicatorsForm'
import ReportIndicatorsPsychForm from '@/components/reports/new/ReportIndicatorsPsychForm'
import ReportSeminars from '@/components/reports/new/ReportSeminars'
import ReportPsychologistsNew from '@/components/reports/new/ReportPsychologistsNew'
import ReportPsychCustomersList from '@/components/reports/new/ReportPsychCustomersList'
// import ReportLawyers from '@/components/reports/new/ReportLawyers'
import ReportLawyersNew from '@/components/reports/new/ReportLawyersNew'
import ReportLGBTQ from '@/components/reports/new/ReportLGBTQ'

//indicators
import ReportController from '@/components/reports/pages/indicators/ReportController'

import ReportPerPerson from '@/components/reports/pages/ReportPerPerson/ReportPerPerson'

//other
import ReportSeminarsAttenders from '@/components/reports/pages/ReportSeminarsAttenders'
import ReportUsersWork from '@/components/reports/pages/ReportUsersWork'
import ReportCharacteristicsCustomers from '@/components/reports/pages/ReportCharacteristicsCustomers'
import ReportAges from '@/components/reports/pages/ReportAges'
// import ReportCaseHelp from '@/components/reports/pages/ReportCaseHelp'
import ReportMedia from '@/components/reports/pages/ReportMedia'

import CustomersTableContent from '@/components/tables/CustomersTableContent'
import Login from '@/components/Login'


import ProductTypesTable from '@/components/tables/ProductTypesTable'
import DiseaseTypesTable from '@/components/tables/DiseaseTypesTable'
import ConsultTypesTable from '@/components/tables/ConsultTypesTable'
import GlobalIndicatorsTable from '@/components/tables/GlobalIndicatorsTable'
import ReportsList from '@/components/reports/ReportsList'

import {store} from '@/store'
import AsyncComputed from 'vue-async-computed'
// import ClassificatorsTable from '../components/tables/ClassificatorsTable'
import PlacesTable from '../components/tables/PlacesTable'
import ProjectsTable from '../components/tables/ProjectsTable'
import ProfilesTable from '../components/tables/ProfilesTable'
import UsersTable from '../components/tables/UsersTable'
import ProductsTable from '../components/tables/ProductsTable'
import ConsultingsTable from '../components/tables/ConsultingsTable'
import DirectionsTable from '../components/tables/DirectionsTable'
import TestsTable from '../components/tables/TestsTable'
import CustomerGroupsTable from '../components/tables/CustomerGroupsTable'
import RolesTable from '../components/tables/RolesTable'
import internalComponents from '../components/internalComponents'

import {isValidJwt} from '../utils'

Vue.use(Router)
Vue.use(AsyncComputed)

let dictRoutes = [ {
      path: '/customers',
      name: 'CustomersTable',
      component: CustomersTableContent
    },
    {
      path: '/productTypes',
      name: 'ProductTypesTable',
      component: ProductTypesTable
    },
  {
      path: '/diseaseTypes',
      name: 'DiseaseTypesTable',
      component: DiseaseTypesTable
    },
  {
      path: '/consultstype',
      name: 'ConsultTypesTable',
      component: ConsultTypesTable
    },
    // {
    //   path: '/classificators',
    //   name: 'ClassificatorsTable',
    //   component: ClassificatorsTable
    // },
    {
      path: '/places',
      name: 'PlacesTable',
      component: PlacesTable
    },
  {
      path: '/projects',
      name: 'ProjectsTable',
      component: ProjectsTable
    },
  {
      path: '/profiles',
      name: 'ProfilesTable',
      component: ProfilesTable
    },
    {
      path: '/roles',
      name: 'RolesTable',
      component: RolesTable
    },
    {
      path: '/groups',
      name: 'CustomerGroupsTable',
      component: CustomerGroupsTable
    },
    {
      path: '/users',
      name: 'UsersTable',
      component: UsersTable,
      beforeEnter: (to, from, next) => {
        if (!store.state.tableData.roles || store.state.tableData.roles.length === 0) {
          store.dispatch("tableData/loadRoles")
        }
        next()
      }
    },
    {
      path: '/products',
      name: 'ProductsTable',
      component: ProductsTable,
      beforeEnter: (to, from, next) => {
        if (!store.state.tableData.productTypes || store.state.tableData.productTypes.length === 0) {
          store.dispatch("tableData/loadProductTypes")
        }
        // if (!store.state.tableData.classificators || store.state.tableData.classificators.length === 0) {
        //   store.dispatch("tableData/loadClassificators")
        // }
        // store.dispatch("tableData/loadProductTypes")
        // store.dispatch("tableData/loadClassificators")
        next()
      }
    },
    {
      path: '/consultings',
      name: 'ConsultingsTable',
      component: ConsultingsTable,
      beforeEnter: (to, from, next) => {
        store.dispatch("tableData/loadConsultationTypes")
        // store.dispatch("tableData/loadClassificators")
        next()
      }
    },
  {
      path: '/globalindicators',
      name: 'GlobalIndicatorsTable',
      component: GlobalIndicatorsTable,
    },
  {
      path: '/directions',
      name: 'DirectionsTable',
      component: DirectionsTable,
      beforeEnter: (to, from, next) => {
        store.dispatch("tableData/loadProductTypes")
        // store.dispatch("tableData/loadClassificators")
        next()
      }
    },
  {
      path: '/tests',
      name: 'TestsTable',
      component: TestsTable,
      beforeEnter: (to, from, next) => {
        store.dispatch("tableData/loadDiseaseTypes")
        // store.dispatch("tableData/loadClassificators")
        next()
      }
    }

]
let reportsRoutes = [  {
      path: '/indicators',
      name: 'ReportController',
      component: ReportController
    },
    {
      path: '/person_detailed',
      name: 'ReportPerPerson',
      component: ReportPerPerson,
      beforeEnter: (to, from, next) => {
        if (!store.state.tableData.products || store.state.tableData.products.length === 1) {
          store.dispatch("tableData/loadProducts", {
            showDeleted: true
          })
        }
        store.dispatch("detailedReports/loadReports")

        next()
      }
    },
    {
      path: '/users_work',
      name: 'ReportUsersWork',
      component: ReportUsersWork,
      beforeEnter: (to, from, next) => {
        if (!store.state.tableData.users || store.state.tableData.users.length === 0) {
          store.dispatch("tableData/loadUsers")
        }
        next()
      }
    },
    {
      path: '/media',
      name: 'ReportMedia',
      component: ReportMedia,
      beforeEnter: (to, from, next) => {
        if (!store.state.tableData.users || store.state.tableData.users.length === 0) {
          store.dispatch("tableData/loadUsers")
        }
        next()
      }
    },
    {
      path: '/cust_char',
      name: 'ReportCharacteristicsCustomers',
      component: ReportCharacteristicsCustomers,
      beforeEnter: (to, from, next) => {
        if (!store.state.tableData.places || store.state.tableData.places.length === 0) {
          store.dispatch("tableData/loadPlaces")
        }
        next()
      }
    },
    {
      path: '/seminars_report',
      name: 'ReportSeminarsAttenders',
      component: ReportSeminarsAttenders
    },
    {
      path: '/cust_ages',
      name: 'ReportAges',
      component: ReportAges,
      beforeEnter: (to, from, next) => {
        if (!store.state.tableData.places || store.state.tableData.places.length === 0) {
          store.dispatch("tableData/loadPlaces")
        }
        next()
      }
    },
    // {
    //   path: '/customer_case_help',
    //   name: 'ReportCaseHelp',
    //   component: ReportCaseHelp,
    //   beforeEnter: (to, from, next) => {
    //     if (!store.state.tableData.places || store.state.tableData.places.length === 0) {
    //       store.dispatch("tableData/loadPlaces")
    //     }
    //     next()
    //   }
    // },
]
let reportsNewRoute = [    {
      path: '/reports',
      name: 'ReportsList',
      component: ReportsList,
      beforeEnter: (to, from, next) => {
        if (!store.state.tableData.users || store.state.tableData.users.length === 0) {
          store.dispatch("tableData/loadUsers")
        }
        if (!store.state.tableData.places || store.state.tableData.places.length === 0) {
          store.dispatch("tableData/loadPlaces")
        }
        next()
      }

    },
    {
      path: '/outreach/:reportId',
      component: ReportBase,
      props: true,
      meta: {reportType: 'outreach'},
      beforeEnter: async (to, from, next) => {
        if(to.params.reportId === 'new' && store.state.newOutreachReports.id !== 'new') {
          store.commit("newOutreachReports/clearReport")
        }
        store.dispatch('loader/showLoader')
        if (!store.state.tableData.projects || store.state.tableData.projects.length === 0) {
          store.dispatch("tableData/loadProjects")
        }
        if (!store.state.tableData.profiles || store.state.tableData.profiles.length === 0) {
          store.dispatch("tableData/loadProfiles")
        }
        // if (!store.state.tableData.products || store.state.tableData.products.length === 0) {
        store.dispatch("tableData/loadProducts")
        // if (!store.state.tableData.consultings || store.state.tableData.consultings.length === 0) {
        store.dispatch("tableData/loadConsultings")

        // }
        if (!store.state.tableData.tests || store.state.tableData.tests.length === 0) {
          store.dispatch("tableData/loadTests")
        }
        if (!store.state.tableData.directions || store.state.tableData.directions.length === 0) {
          store.dispatch("tableData/loadDirections")
        }
        if (!store.state.tableData.places || store.state.tableData.places.length === 0) {
          store.dispatch("tableData/loadPlaces")
        }
        if (!store.state.tableData.users || store.state.tableData.users.length === 0) {
          store.dispatch("tableData/loadUsers")
        }
        if (!store.state.tableData.customerGroups || store.state.tableData.customerGroups.length === 0) {
          store.dispatch("tableData/loadCustomerGroups")
        }
        if(to.params.reportId !== 'new') {
          try {
            await store.dispatch('newOutreachReports/load', {reportId:to.params.reportId,type:'outreach'})
            next()
          } catch (e) {
            store.dispatch('alert/error', `Не удалось найти отчет ${to.params.reportId}`)
            next(false)
          }
          finally {
            store.dispatch('loader/hideLoader')
          }
        } else {
          store.dispatch('loader/hideLoader')
          next()
        }
      },
      children: [
        {
          path: '',
                    meta: {reportType: 'outreach'},

          redirect: 'form',
        },
        {
          path: 'form',
          name: 'ReportOutreachForm',
          props: true,
          meta: {reportType: 'outreach'},
          component: ReportOutreachNew,
          beforeEnter: async (to, from, next) => {
            if(to.params.reportId === 'new' && from.fullPath !== "/outreach/new/list") {
              store.commit("newOutreachReports/clearReport")
            }
            next()
          }
        },
        {
          path: 'list',
          name: 'ReportOutreachList',
          props: true,
          meta: {reportType: 'outreach'},
          component: ReportOutreachList
        },
        {
          path: 'client/:customerId',
          name: 'ReportOutreachClient',
          props: true,
          meta: {reportType: 'outreach'},
          component: ReportIndicatorsForm
        }
      ]
    },
    {
      path: '/case/:reportId',
      component: ReportBase,
      props: true,
      meta: {reportType: 'casemanagement'},
      beforeEnter: async (to, from, next) => {
        store.dispatch('loader/showLoader')

        if(to.params.reportId === 'new' && store.state.newOutreachReports.id !== 'new') {
          store.commit("newOutreachReports/clearReport")
        }
        // store.commit("newOutreachReports/clearReport")
        if (!store.state.tableData.products || store.state.tableData.products.length === 0) {
          store.dispatch("tableData/loadProducts")
        }
        if (!store.state.tableData.consultings || store.state.tableData.consultings.length === 0) {
          store.dispatch("tableData/loadConsultings")
        }
        if (!store.state.tableData.users || store.state.tableData.users.length === 0) {
          store.dispatch("tableData/loadUsers")
        }
        //console.log(store.state.tableData.globalIndicators)
        if (!store.state.tableData.globalIndicators || store.state.tableData.globalIndicators.length === 0) {
          store.dispatch("tableData/loadGlobalIndicators")
        }
        if(to.params.reportId !== 'new') {
          try {
            await store.dispatch('newOutreachReports/load',  {reportId:to.params.reportId,type:'casemanagement'})
            next()
          } catch (e) {
            store.dispatch('alert/error', `Не удалось найти отчет ${to.params.reportId}`)
            next(false)
          }
          finally {
            store.dispatch('loader/hideLoader')
          }
        } else {
          store.dispatch('loader/hideLoader')
          next()
        }
      },
      children: [
        {
          path: '',
          meta: {reportType: 'casemanagement'},
          redirect: 'form',
        },
        {
          path: 'form',
          name: 'ReportCaseForm',
          props: true,
          meta: {reportType: 'casemanagement'},
          component: ReportOutreachNew,
          beforeEnter: async (to, from, next) => {
            if(to.params.reportId === 'new' && from.fullPath !== "/case/new/list"){
              store.commit("newOutreachReports/clearReport")
            }
            next()
          }
        },
        {
          path: 'list',
          name: 'ReportCaseList',
          props: true,
          meta: {reportType: 'casemanagement'},
          component: ReportOutreachList
        },
        {
          path: 'client/:customerId',
          name: 'ReportCaseClient',
          props: true,
          meta: {reportType: 'casemanagement'},
          component: ReportIndicatorsForm
        }
      ]
    },
      {
      path: '/psych/:reportId',
      component: ReportBase,
      props: true,
      meta: {reportType: 'psych'},
      beforeEnter: async (to, from, next) => {
        // store.dispatch('loader/showLoader')
        // }
        if(to.params.reportId === 'new' && store.state.newOutreachReports.id !== 'new') {
          //console.log('clearing',from.fullPath,to)
          store.commit("newOutreachReports/clearReport")
        }
        // store.commit("newOutreachReports/clearReport")
        if (!store.state.tableData.consultings || store.state.tableData.consultings.length === 0) {
          store.dispatch("tableData/loadConsultings")
        }
        // if (!store.state.tableData.profiles || store.state.tableData.profiles.length === 0) {
        //   store.dispatch("tableData/loadProfiles")
        // }
        if (!store.state.tableData.users || store.state.tableData.users.length === 0) {
          store.dispatch("tableData/loadUsers")
        }
        if(to.params.reportId !== 'new') {
          try {
            //console.log('something else')
            await store.dispatch('newOutreachReports/load',  {reportId:to.params.reportId,type:'psych'})

            next()
          } catch (e) {
            store.dispatch('alert/error', `Не удалось найти отчет ${to.params.reportId}`)
            next(false)
          }
          finally {
            store.dispatch('loader/hideLoader')
          }
        } else {
          next()
        }
      },
      children: [
        {
          path: '',
          meta: {reportType: 'psych'},
          redirect: 'form',
        },
        {
          path: 'form',
          name: 'ReportPsychForm',
          props: true,
          meta: {reportType: 'psych'},
          component: ReportPsychologistsNew,
          beforeEnter: async (to, from, next) => {
            if(to.params.reportId === 'new' && from.fullPath !== "/psych/new/list"){
              //console.log('psyyyyych form')
              store.commit("newOutreachReports/clearReport")
            }
            if (!store.state.tableData.consultings || store.state.tableData.consultings.length === 0) {
              store.dispatch("tableData/loadConsultings")
            }
            next()
          }
        },
        {
          path: 'list',
          name: 'ReportPsychList',
          props: true,
          meta: {reportType: 'psych'},
          component: ReportPsychCustomersList
        },
        {
          path: 'consults',
          name: 'ReportPsychClient',
          props: true,
          meta: {reportType: 'psych'},
          component: ReportIndicatorsPsychForm
        }
      ]
    },
    {
      path: '/lawyers/:reportId',
      component: ReportBase,
      props: true,
      meta: {reportType: 'lawyers'},
      beforeEnter: async (to, from, next) => {
        if(to.params.reportId === 'new' && store.state.newOutreachReports.id !== 'new') {
          store.commit("newOutreachReports/clearReport")
        }
        if (!store.state.tableData.products || store.state.tableData.products.length === 0) {
          store.dispatch("tableData/loadConsultings")
        }
        if (!store.state.tableData.users || store.state.tableData.users.length === 0) {
          store.dispatch("tableData/loadUsers")
        }
        if(to.params.reportId !== 'new') {
          try {
            await store.dispatch('newOutreachReports/load',  {reportId:to.params.reportId,type:'lawyers'})
            next()
          } catch (e) {
            store.dispatch('alert/error', `Не удалось найти отчет ${to.params.reportId}`)
            next(false)
          }
          finally {
            store.dispatch('loader/hideLoader')
          }
        } else {
          next()
        }
      },
      children: [
        {
          path: '',
          meta: {reportType: 'lawyers'},
          redirect: 'form',
        },
        {
          path: 'form',
          name: 'ReportLawyerForm',
          props: true,
          meta: {reportType: 'lawyers'},
          component: ReportLawyersNew,
          beforeEnter: async (to, from, next) => {
            if(to.params.reportId === 'new' && from.params.reportId !== 'new'){
              store.commit("newOutreachReports/clearReport")
            }
            next()
          }
        },
        {
          path: 'list',
          name: 'ReportLawyerList',
          props: true,
          meta: {reportType: 'lawyers'},
          component: ReportCustomersList
        },
        {
          path: 'client/:customerId',
          name: 'ReportLawyerClient',
          props: true,
          meta: {reportType: 'lawyers'},
          component: ReportIndicatorsForm
        }
      ]

    },
  {
      path: '/seminars',
      name: 'ReportSeminars',
      props: true,
      meta: {reportType: 'seminar'},
      component: ReportSeminars
    },
    {
      path: '/seminars/:reportId',
      name: 'ReportSeminarsUpdate',
      props: true,
      meta: {reportType: 'seminar'},
      component: ReportSeminars
    },
    {
      path: '/lgbtq',
      name: 'ReportLGBTQ',
      props: true,
      meta: {reportType: 'lgbtq'},
      component: ReportLGBTQ,
      beforeEnter: async (to, from, next) => {
        if (!store.state.tableData.consultings || store.state.tableData.consultings.length === 0) {
          store.dispatch("tableData/loadConsultings")
        }
        if (!store.state.tableData.products || store.state.tableData.products.length === 0) {
          await store.dispatch("tableData/loadProducts")
        }
        next()
      }
    },
    {
      path: '/lgbtq/:reportId',
      name: 'ReportLGBTQUpdate',
      props: true,
      meta: {reportType: 'lgbtq'},
      component: ReportLGBTQ,
      beforeEnter: async (to, from, next) => {
        if (!store.state.tableData.products || store.state.tableData.products.length === 0) {
          store.dispatch("tableData/loadProducts")
        }
        if (!store.state.tableData.consultings || store.state.tableData.consultings.length === 0) {
          store.dispatch("tableData/loadConsultings")
        }
        next()
      }
    },]
export const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      props: (route) => ({token: route.query.token}),
      component: Login
    },
    ...dictRoutes,
    ...reportsRoutes,
    ...reportsNewRoute,
    {
      path: '/versions',
      name: 'internalComponents',
      component: internalComponents
    },

    {path: '', redirect: '/outreach/new/form'},
    {path: '*', redirect: '/outreach/new/form'}
    // {
    //   path: '/upload_report',
    //   name: 'ReportExcel',
    //   component: ReportExcel
    // },
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/password_reset']
  const authRequired = !publicPages.includes(to.path)
  let user = JSON.parse(localStorage.getItem('user'))
  let token = user ? user['token'] : null
  if (to.name === 'PasswordReset' && !isValidJwt(token) && authRequired) {
    return next(to.path)
  }
  if (authRequired && !isValidJwt(token)) {
    return next('/login')
  }
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js